<template>
  <div>
    <!-- header -->
    <header>
      <section
        class="w-full p-1 min-h-[7vh] flex justify-end border border-gray-300 rounded-2xl"
      >
        <button
          id="dropdownAvatarNameButton"
          data-dropdown-toggle="dropdownAvatarName"
          class="flex items-center text-sm pe-1 font-medium text-gray-600 rounded-full hover:text-gray-950 md:me-0 focus:ring-4 focus:ring-gray-100"
          type="button"
        >
          <span class="sr-only">Open drop</span>
          <img
            class="w-11 h-11 rounded-full"
            :src="imgDefault"
            :alt="profileName"
          />

          <div class="pl-2 mt-auto mb-auto text-left">
            <div class="text-base font-semibold">
              {{
                profileName?.length > 10
                  ? profileName.slice(0, 10).concat("...")
                  : profileName
              }}
            </div>

            <div class="font-normal text-gray-500 -mt-2">
              <small>
                {{
                  // profileRole?.length > 10
                  //   ? profileRole.slice(0, 10).concat("...")
                  //   : profileRole
                  "root"
                }}
              </small>
            </div>
          </div>

          <div class="mt-auto mb-auto ml-2">
            <component :is="PhCaretDown" class="h-4 w-4" />
          </div>
        </button>

        <div
          id="dropdownAvatarName"
          class="z-40 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44"
        >
          <div class="px-0.5 py-3 text-sm text-gray-900">
            <p>
              {{
                // companyName?.length > 20
                //   ? companyName.slice(0, 20).concat("...")
                //   : companyName
                "Fácil Consulta"
              }}
            </p>
          </div>

          <ul
            class="py-2 text-sm text-gray-700"
            aria-labelledby="dropdownInformdropdownAvatarNameButtonationButton"
          >
            <li>
              <a
                aria-disabled="true"
                href="#"
                class="block px-4 py-2 hover:bg-gray-100"
              >
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhBuildingApartment"
                  ></component>
                  Filiais
                </p>
              </a>
            </li>

            <li>
              <router-link class="block px-4 py-2 hover:bg-gray-100" to="#">
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhUser"
                  ></component>
                  Meu perfil
                </p>
              </router-link>
            </li>
            <li>
              <router-link class="block px-4 py-2 hover:bg-gray-100" to="#">
                <p class="flex justify-center w-full">
                  <component
                    class="h-4 w-4 mt-auto mb-auto mr-2"
                    :is="PhBuilding"
                  ></component>
                  Empresa
                </p>
              </router-link>
            </li>
          </ul>

          <div class="py-2">
            <router-link
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              to="logout"
            >
              <p class="flex justify-center w-full">
                <component
                  class="h-4 w-4 mt-auto mb-auto mr-2"
                  :is="PhSignOut"
                ></component>
                Sign out
              </p>
            </router-link>
          </div>
        </div>
      </section>
    </header>

    <section class="px-3 pb-2">
      <div class="flex justify-between p-1 md:p-1 w-full">
        <div class="md:mt-0 text-left mt-auto mb-auto">
          <h1
            class="font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-4xl"
            :class="[small ? 'text-2xl' : 'text-4xl']"
          >
            <span
              class="text-transparent bg-clip-text bg-gradient-to-r from-[#0584db] to-[#024d83]"
            >
              <slot />
            </span>
          </h1>
          <div class="w-full text-left">
            <small class="text-left font-normal text-gray-500">
              {{ props.subTitle }}
            </small>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import {
  PhBuilding,
  PhBuildingApartment,
  PhCaretDown,
  PhSignOut,
  PhUser,
} from "@phosphor-icons/vue";
import { computed } from "vue";
import { defineProps } from "vue";
import { onMounted } from "vue";
import { initFlowbite } from "flowbite";

const profileName = computed(() => localStorage.getItem("__user_name"));
const imgDefault = require("@/assets/logo/icon.png");

const props = defineProps({
  subTitle: {
    type: String,
    require: false,
  },
});

onMounted(() => {
  initFlowbite();
});
</script>
